<div>
  <form [formGroup]="addressForm">
    <div class="row">
      <div class="col-md-4 col-12">
        <form-helper class="form-group" [control]="controls.cep">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " mask="00000-000" formControlName="cep" />
            <label class="required" for="cep">CEP</label>
          </div>
        </form-helper>
      </div>
      <div class="col-md-4 col-12">
        <form-helper class="form-group" [control]="controls.uf">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " mask="SS" formControlName="uf" />
            <label class="required" for="uf">Estado</label>
          </div>
        </form-helper>
      </div>
      <div class="col-md-4 col-12">
        <form-helper class="form-group" [control]="controls.city">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="city" />
            <label class="required" for="city">Cidade</label>

          </div>
        </form-helper>
      </div>
      <div class="col-md-4 col-12">
        <form-helper class="form-group" [control]="controls.district">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="district" />
            <label class="required" for="district">{{ districtLabel }}</label>

          </div>
        </form-helper>
      </div>
      <div class="col-md-8 col-12">
        <form-helper class="form-group" [control]="controls.logradouro">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="logradouro" />
            <label class="required" for="logradouro">Logradouro</label>

          </div>
        </form-helper>
      </div>
      <div class="col-md-4 col-12">
        <form-helper class="form-group" [control]="controls.number">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="number" />
            <label class="required" for="number">Número</label>

          </div>
        </form-helper>
      </div>
      <div class="col-md-8 col-12">
        <form-helper class="form-group" [control]="controls.complemento">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="complemento" />
            <label for="complemento">Complemento</label>

          </div>
        </form-helper>
      </div>
    </div>
  </form>
</div>
